export default {
  tag: "Regulaciones y Cumplimiento",
  title1: "Permisos, Licencias y",
  title2: "Requisitos Regulatorios",
  subtitle:
    "Una guía de referencia completa para cada permiso y licencia requeridos, y asociarte con una ciudad para operar tu food truck en el Condado de Orange, CA. Las tres categorías — negocio, salud y vehículo — en un solo lugar.",
  viewFullGuide: "Ver la Guía Completa",
  ctaTitle: "¿Necesitas ayuda para navegar estos requisitos?",
  ctaText:
    "Nuestro equipo se encarga de las solicitudes de permisos, renovaciones y seguimiento de cumplimiento para que puedas concentrarte en tu comida y tus clientes.",
  bookSession: "Reservar una Sesión",
  backHome: "Volver al Inicio",
  disclaimerTitle: "Aviso Legal:",
  disclaimerText:
    "Los requisitos de permisos y las tarifas cambian con frecuencia. Esta guía refleja las regulaciones actuales del Condado de Orange a partir de 2025 y está destinada únicamente a fines informativos generales. Recomendamos encarecidamente reservar una consulta con nuestro equipo para obtener una orientación precisa y actualizada para tu situación específica.",
  categories: [
    {
      id: "business",
      label: "Licencias Comerciales",
      title: "Licencias Comerciales y Permisos del Condado",
      badge: "Requerido Antes de Abrir",
      items: [
        {
          name: "Licencia Comercial de la Ciudad",
          authority: "Cada Ciudad Donde Operas",
          renewal: "Anualmente",
          note: "Requerida en cada ciudad donde vendes. Anaheim, Irvine y Santa Ana tienen sus propios permisos de vendedor móvil.",
        },
        {
          name: "Permiso de Vendedor (Impuesto de Ventas)",
          authority: "CDTFA de California",
          renewal: "No requiere renovación",
          note: "Requerido para cobrar y remitir el impuesto de ventas de California. Solicítalo en línea en cdtfa.ca.gov.",
        },
        {
          name: "Nombre Comercial Ficticio (DBA)",
          authority: "Secretario del Condado de Orange",
          renewal: "Cada 5 años",
          note: "Requerido si operas bajo un nombre diferente de tu nombre comercial legal.",
        },
        {
          name: "Solicitudes de Revisión de Planos",
          authority: "Salud Ambiental del Condado de Orange",
          renewal: "Solo al modificar el diseño o el equipo",
          note: "Se presenta antes de la construcción o remodelación. Debe incluir planos de planta detallados, especificaciones del equipo y diagramas de plomería/eléctricos.",
        },
      ],
    },
    {
      id: "hcd-insignia",
      label: "HCD: Etiqueta de Insignia",
      title: "Certificación HCD y Etiqueta de Insignia",
      badge: "Obligatorio por el Estado",
      items: [
        {
          name: "Solicitud HCD 415",
          authority: "HCD de California / Salud Ambiental del Condado de Orange",
          renewal: "Sin vencimiento fijo — sin límite de años",
          note: "Certificación estatal para unidades de comida móvil bajo la Sección 113725 del Código de Salud y Seguridad de California. Requerida antes de que se pueda emitir el permiso MFF del condado. No hay límite de años en esta certificación — una vez aprobada, permanece válida indefinidamente a menos que se realicen modificaciones significativas a la unidad.",
        },
        {
          name: "Actualización de Equipo MFF 1980–2006",
          authority: "HCD de California",
          renewal: "Requisito de actualización único",
          note: "Las Instalaciones de Comida Móvil fabricadas entre 1980 y 2006 operan con equipo de cocina obsoleto que ya no cumple con los estándares actuales de HCD. Estas unidades deben someterse a una actualización integral del equipo — incluyendo refrigeración de grado comercial, ventilación y electrodomésticos de cocina — antes de poder recibir o renovar su certificación de etiqueta de insignia.",
        },
      ],
    },
    {
      id: "health",
      label: "Salud y Seguridad Alimentaria",
      title: "Permisos de Salud y Requisitos de Seguridad Alimentaria",
      badge: "Estrictamente Aplicado",
      items: [
        {
          name: "Tarjeta de Manipulador de Alimentos",
          authority: "Salud Ambiental del Condado de Orange",
          renewal: "Cada 3 años",
          note: "Todos los manipuladores de alimentos deben llevar una tarjeta de manipulador de alimentos válida mientras trabajan en el camión.",
        },
        {
          name: "Certificación de Gerente de Alimentos",
          authority: "ServSafe / Acreditado por ANSI",
          renewal: "Cada 5 años",
          note: "Se requiere al menos un gerente certificado de protección de alimentos en el lugar durante el horario de operación.",
        },
        {
          name: "Inspección de Salud del Condado de Orange",
          authority: "División de Salud Ambiental del Condado de Orange",
          renewal: "2 veces al año (sin aviso)",
          note: "Los inspectores verifican las temperaturas de los alimentos, la higiene, la limpieza del equipo y el cumplimiento de la comisaría.",
        },
        {
          name: "Aprobación de Salud de la Comisaría",
          authority: "Salud Ambiental del Condado de Orange",
          renewal: "Anualmente",
          note: "Tu comisaría también debe estar permitida por Salud Ambiental del Condado de Orange y debe coincidir con tu permiso MFF.",
        },
        {
          name: "Permiso de Salud",
          authority: "Salud Ambiental del Condado de Orange",
          renewal: "Anualmente",
          note: "Requerido para todas las operaciones de preparación y venta de alimentos. Cubre saneamiento, almacenamiento de alimentos y estándares de equipo.",
        },
      ],
    },
    {
      id: "vehicle",
      label: "Vehículo y Comisaría",
      title: "Requisitos de Vehículo, Seguridad contra Incendios y Comisaría",
      badge: "Lista de Verificación Antes del Lanzamiento",
      items: [
        {
          name: "Registro de Vehículo Comercial del DMV",
          authority: "DMV de California",
          renewal: "Anualmente",
          note: "Tu food truck debe registrarse como vehículo comercial. Puede requerirse una licencia Clase B o C dependiendo del peso del vehículo.",
        },
        {
          name: "Sistema de Supresión de Incendios (Ansul)",
          authority: "Departamento de Bomberos Local",
          renewal: "Inspección de servicio semestral",
          note: "Obligatorio para todo el equipo de cocina que produce vapores cargados de grasa (freidoras, parrillas, etc.).",
        },
        {
          name: "Carta de Acuerdo de Comisaría",
          authority: "Comisaría con Licencia del Condado de Orange",
          renewal: "Contrato continuo",
          note: "Debes regresar a tu comisaría para la limpieza diaria, reabastecimiento y eliminación de residuos. Debe estar a una distancia razonable de tu área de operación.",
        },
      ],
    },
  ],
};